import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import { fetchGameBundles } from 'Redux/ducks/algolia-calls';
import ProductCarouselSection from 'Containers/HomePage/ProductCarouselSection';

const messages = defineMessages({
  title: {
    id: 'game-bundles.title',
    defaultMessage: 'Game Bundles',
  },
});

const GameBundleSection = ({ hits, intl, slugToRemove }) => {
  const [bundleHits, setBundleHits] = useState([]);

  const { formatMessage } = intl;

  useEffect(() => {
    const fetchBundles = async () => {
      const newHits = await fetchGameBundles(slugToRemove);
      return setBundleHits(newHits);
    };

    if (isEmpty(hits)) {
      fetchBundles();
    }
    if (!isEmpty(hits)) {
      setBundleHits(hits);
    }
  }, [hits, slugToRemove]);

  return (
    <ProductCarouselSection
      title={formatMessage(messages.title)}
      viewAllLocation="bundle/games"
      loadedHits={bundleHits}
      viewAllTitle={formatMessage(messages.title)}
      hitCardNameTag="h3"
      itemListTitle="Game Bundles"
      showHeader={false}
    />
  );
};

GameBundleSection.propTypes = {
  hits: PropTypes.arrayOf(PropTypes.shape({})),
  slugToRemove: PropTypes.string,
};

GameBundleSection.defaultProps = {
  hits: [],
  slugToRemove: '',
};

export default injectIntl(GameBundleSection);
